app.controller("OrganizationalEmployeesController", [
    "$scope", "$uibModal", "OrganizationalUnit", "Position", "StaticData", "ConfirmModal", "$stateParams", "$state", "toastr", "DocumentsService",
    function ($scope, $uibModal, OrganizationalUnit, Position, StaticData, ConfirmModal, $stateParams, $state, toastr, DocumentsService) {

        $scope.staff = [];
        $scope.unit = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;

        OrganizationalUnit.getById($stateParams.unit).then(function (unit) {
            $scope.unit = unit;
        });

        Position.list({
            organization: $stateParams.unit
        }).then(function (data) {
            $scope.positionsMap = _.keyBy(data.docs, '_id');
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });


        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                page: 1
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };

            DocumentsService.staffList({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                organizationId: $stateParams.unit
            }).then(function (data) {
                $scope.employees = data.docs;
                $scope.totalItems = data.total;

                data.docs.forEach(function (employee) {
                    if (!employee.user.photo) {
                        if (employee.user.gender) {
                            if (employee.user.gender === 'male') employee.user.photo = "img/male.jpg";
                            else employee.user.photo = "img/female.jpg";
                        }
                        else {
                            employee.user.photo = "img/no_image.jpg";
                        }
                    }
                });

                cb();
            });
        }

        $scope.add = function () {
                $uibModal.open({
                controller: "OrganizationalEmployAddController",
                templateUrl: _pb + 'employee/organizational-units/organizational-employee-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            action: 'add',
                            employee: null,
                            unitId: $scope.unit._id
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.edit = function (employee, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "OrganizationalEmployAddController",
                templateUrl: _pb + 'employee/organizational-units/organizational-employee-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            action: 'edit',
                            employee: employee,
                            unitId: $scope.unit._id
                        };
                    }
                }
            }).result
                .then(function () {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.remove = function (employee, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "თანამშრომლის წაშლა",
                message: "გსურთ " + employee.user.firstName + " " + employee.user.lastName + " წაშალოთ თანამშრომლების სიიდან?"
            }).result.then(function () {
                DocumentsService.staffRemoveFromOrg(employee._id).then(function () {
                    toastr.success('', 'თანამშრომელი წარმატებით წაიშალა სიიდან');
                    loadPage($stateParams.page);
                }).catch(function(err) {
                    if (err.status === 400) {
                        toastr.error('', 'დაფიქსირდა შეცდომა!');
                    }
                });
            });
        };
    }
]);
